/**
 * Unauthorized Page
 *
 * Shown when user tries to access admin-only routes without admin privileges.
 */

import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Alert } from '../components/ui/Alert';
import { ShieldExclamationIcon } from '@heroicons/react/24/outline';

export const UnauthorizedPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: 'var(--color-bg-primary)' }}>
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-yellow-100">
            <ShieldExclamationIcon className="h-10 w-10 text-yellow-600" />
          </div>
          <h2 className="mt-6 text-3xl font-bold" style={{ color: 'var(--color-text-primary)' }}>
            Access Denied
          </h2>
          <div className="mt-4">
            <Alert variant="warning">
              You do not have permission to access this page. This area is restricted to administrators only.
            </Alert>
          </div>
        </div>

        <div className="text-center space-y-2">
          <Button
            variant="primary"
            onClick={() => navigate('/app/dashboard')}
            fullWidth
          >
            Go to Dashboard
          </Button>
          <p className="text-sm" style={{ color: 'var(--color-text-secondary)' }}>
            or{' '}
            <Link to="/app/launcher" className="font-medium text-primary-600 hover:text-primary-500">
              view your applications
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
